import '../App.css';
import React from 'react';
// import { Form } from 'react-bootstrap';
import Moment from 'moment-timezone';
import { connect } from 'react-redux'
import Table from 'react-bootstrap/Table'
import Alert from 'react-bootstrap/Alert'
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { language } from '../language';
import Loading from '../Images/loading.gif';
// import updown from '../Images/updown1.png';
import Pagination from 'react-bootstrap/Pagination';
import SideBar from '../Component/SideBar';

const { accountReportDetail } = require('../Api');
// import { Link } from 'react-router-dom';
// import { isMobile } from 'react-device-detect';  (isMobile) ?
var timer

function PlatformChange(platform) {
  if (platform === '1') return 'M'
  else if (platform === '2') return 'K'
  else if (platform === '3') return 'T'
  else if (platform === '4') return 'S'
  else if (platform === '5') return 'W'
  else if (platform === '6') return 'B'
  else if (platform === '7') return 'D'
  else if (platform === '8') return '8'
  else if (platform === '9') return '9'
  return 'null'
}

class DetailPersonaSales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Username: this.props.username,
      TodayDate: Moment(new Date()).format('DD/MM/YYYY (ddd)'),
      SelectedDate: Moment(localStorage.getItem('SELECTED_DATE')).toDate(),
      ChooseStatus: 300,
      GameArray: {},
      UseridReport: '', 
      ReportDetailBet: [],
      notificationType: 'success',
      showNotification: false,
      notificationMessage: '',
      ModeType: 'Detail',
      NotEmpty: true,
      loading: false,
      BigTotal: false, BigB: false, BigS: false, BigCA1: false, BigCC: false, BigA1: false, BigAC: false, BigA2: false,
      BigA3: false, BigAD: false, BigAE: false, Big5D: false,
      Big6D: false,
      page: 0,
      pages: 0,
    }
  }

  async componentDidMount() {
    this.CallApi();
  }

  async CallApi() {
    const SelectedDate = Moment(this.state.SelectedDate).format('YYYY-MM-DD')
    let searchState = this.props.location.search.substring(1, this.props.location.search.length)
    if (searchState !== '') {
      searchState = `{"${decodeURI(searchState.replace(/&/g, "\",\"").replace(/=/g,"\":\""))}"}`
      searchState = JSON.parse(searchState)

      this.setState({ UseridReport: searchState.Username, loading: true })

      const SearchUSerID = (searchState.id.includes('SELF')) ? searchState.id.substring(0, searchState.id.length - 5) : searchState.id
      const AccountReportDetail = await accountReportDetail(SelectedDate, SearchUSerID, this.props.username, this.props.token, this.state.page)
      if(AccountReportDetail.message === 'No Data For Selected Date') {
        this.setState({ NotEmpty: true, ReportDetailBet: [], loading: false })
      } else if(AccountReportDetail.error === 'database error') {
        this.setState({ NotEmpty: true, ReportDetailBet: [], loading: false })
      } else {
        const totalPages = Math.max(1, Math.ceil(AccountReportDetail.total / 50));
        console.log(totalPages)
        this.setState({ ReportDetailBet: AccountReportDetail.report, NotEmpty: false, loading: false, pages: totalPages })
      }
    } else {
      this.setState({ UseridReport: 'No User', ReportDetailBet: [], NotEmpty: true, loading: false })
    }
  }
  
  openNotification(message) {
    this.setState({ showNotification: true });
    this.setState({ notificationMessage: `${language[this.props.currentLanguage][message]}` });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ showNotification: false });
      this.setState({ notificationMessage: '' });
    }, 5000);
  };

  async setSelectedDate(SelectedDate) {
    this.setState({ SelectedDate }, ()=>{
      this.props.setDate(SelectedDate)
      this.CallApi();
    })
  }

  BigToSmall(items) {
    this.setState({ loading: true })
    const ReportDetails = this.state.ReportDetailBet
    if(this.state[`Big${items}`] === false) {
      ReportDetails.sort((a, b) => (a[items] > b[items]) ? -1 : 1)
      this.setState({ [`Big${items}`]: true })
    } else {
      ReportDetails.sort((a, b) => (a[items] > b[items]) ? 1 : -1)
      this.setState({ [`Big${items}`]: false })
    }
    this.setState({ ReportDetails, loading: false })
  }

  render() {
    return (
      <div>
        <SideBar />
        <Alert style={{ zIndex: 99, position: 'fixed', right: 0, top: 100, width:  '70%', left:  250 }} show={this.state.showNotification}
          variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
          <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
        </Alert>
        <div style={{ marginLeft: 150, padding: 10, width: `calc(100% - 150)`, flexDirection: 'column', display: 'flex', alignItems: 'flex-start' }}>
          <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', position: 'fixed', backgroundColor: '#ddd', padding: '10px 10px 0px 10px' }}>
            <div style={{ width: 300, textAlign: 'left', fontWeight: 'bold', fontSize: 20, height: 38}}>{language[this.props.currentLanguage].SelectedUsername} {this.state.UseridReport}</div>
            <Pagination linkStyle={{ marginTop: 0, marginBottom: 0}}>
              <Pagination.Prev
                disabled={this.state.page === 1}
                onClick={() => this.setState({ page: this.state.page -1 }, () => this.CallApi())}
              />
              {/* {[...Array(this.state.pages)].map((_, i) => (
                <Pagination.Item
                  key={i}
                  active={i === this.state.page}
                  onClick={() => this.setState({ page: i }, () => this.CallApi())}
                >
                  {i + 1}
                </Pagination.Item>
              ))} */}
              {(() => {
                const items = [];
                const { page, pages } = this.state;

                for (let i = 0; i < pages; i++) {

                  const pageNum = i + 1;

                  const isFirst = pageNum === 1;
                  const isLast = pageNum === pages;
                  const isNear =
                    (pageNum >= page - 2 && pageNum <= page + 4);

                  if (isFirst || isLast || isNear) {
                    items.push(
                      <Pagination.Item
                        key={i}
                        active={page === i}
                        onClick={() => this.setState({ page: i }, () => this.CallApi())}
                      >
                        {pageNum}
                      </Pagination.Item>
                    );
                  } 
                  else if (pageNum === page - 3 || pageNum === page + 5) {
                    items.push(<Pagination.Ellipsis key={"e"+i} disabled />);
                  }
                }

                return items;
              })()}

              <Pagination.Next
                disabled={this.state.page === this.state.pages}
                onClick={() => this.setState({ page: this.state.page + 1 }, () => this.CallApi())}
              />

            </Pagination>
          </div>
          <div style={{ overflowX: 'auto', marginTop: 90}}>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>{language[this.props.currentLanguage].UserID}</th>
                  <th>{language[this.props.currentLanguage].Games}</th>
                  <th>{language[this.props.currentLanguage].Number}</th>
                  <th><div  onClick={() => this.BigToSmall('Total')} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    {language[this.props.currentLanguage].Total}
                  </div></th>
                  {(this.state.ModeType !== 'Simple') && ['B','S','CA', 'CC', 'SA', 'SD', 'SB', 'SC', 'SE', 'SF', '5D', '6D', 'PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'CB', 'CC', 'CE', 'CF'].map((item, index) => {
                    return(
                      <th key={index}><div  onClick={() => this.BigToSmall(item)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>{item}</div></th>
                    )
                  })
                  }
                </tr>
              </thead>
              <tbody>
                {this.state.loading === true ? (
                  <tr>
                    <td colSpan="30" style={{ backgroundColor: 'white' }}>
                      <img src={Loading} alt="Logo" className="loadingreceiptimages" />
                      <div className="loadingMessageBet">{language[this.props.currentLanguage].LoadingPleaseWaitAMoment}</div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {this.state.NotEmpty === false ? (
                      <>
                        {(this.state.ReportDetailBet || []).map((item, idn) => {
                          return(
                            <tr key={idn}>
                              <td>{item.Username}</td>
                              <td>{PlatformChange(item.Platform)}</td>
                              <td>{item.Word}</td>
                              <td style={{ fontWeight: 'bold'}}>{Number.parseFloat(item.Amount).toFixed(2)}</td>
                              {(this.state.ModeType !== 'Simple') && ['B','S','CA', 'CC', 'SA', 'SD', 'SB', 'SC', 'SE', 'SF', '5D', '6D', 'PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'CB', 'CC', 'CE', 'CF'].map((values, idx) => {
                                return(
                                  <td key={idx}>{(item[values] === null || item[values] === 0) ? '-' : Number.parseFloat(item[values]).toFixed(2)}</td>
                                )
                              })
                              }
                            </tr>
                          )
                        })}
                      </>
                    ) : (
                      <>
                        <tr><td colSpan="30" style={{ backgroundColor: 'gray', fontWeight: 'bold', fontSize: '28px'}}>{language[this.props.currentLanguage].NoData}</td></tr>
                      </>
                    )}
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div >
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    username: state.username,
    token: state.token,
    Role: state.Role,
    userID: state.userID,
    currentLanguage: state.currentLanguage,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setDate: (Date) => {
      dispatch({
        type: 'SELECTED_DATE',
        payload: Date,
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailPersonaSales);